abstract class Finance {
  /**
   * Method to round number
   * @param value
   * @param decimals
   */
  public static round(value: number, decimals = 2): number {
    return parseFloat((value || 0).toFixed(decimals))
  }

  public static roundFull(value: number): number {
    return Math.round(value || 0)
  }

  /**
   * Method to calculate progress in percent
   * @param value
   * @param base
   */
  public static calcProgress = (value: number, base: number): number => {
    if (base && Math.abs(base - value) >= 0.01) {
      const progress = 100 * (value / base) //in percent
      return Finance.round(progress, 2)
    } else {
      return 100
    }
  }

  public static calcProgressFixed = (
    paidPayments: number,
    planPayments: number
  ): number => {
    if (paidPayments === planPayments) {
      return 100
    }

    const progress = 100 * (paidPayments / planPayments)
    return Finance.round(progress, 2)
  }
}

export default Finance
